// Module
var code = `<!-- custom button html -->
<div class="container">
  <div class="icon"></div>
  <div class="title"></div>
</div>
`;
// Exports
export default code;